import { useState } from 'react'
import PhoneInputWithCountry from 'react-phone-number-input/input'
import FormRow from 'components/FormRow'
import 'react-phone-number-input/style.css'
import './PhoneInput.css'
import { PhoneInputProps } from './types'

export default function PhoneInputEui( {
	label,
	value,
	onChange,
	onBlur,
	placeholder,
	isInvalid = false,
	error,
	helpText,
}: PhoneInputProps ) {
	const [ hasBlurred, setHasBlurred ] = useState( false )

	const handleBlur = () => {
		setHasBlurred( true )
		if ( onBlur ) {
			onBlur( value )
		}
	}

	// Only show validation errors after the user has blurred the field
	const shouldShowError = hasBlurred && isInvalid

	return (
		<FormRow
			label={label}
			isInvalid={shouldShowError}
			error={shouldShowError ? error : undefined}
			helpText={helpText}
			fullWidth
		>
			<PhoneInputWithCountry
				country="US"
				value={value || undefined}
				onChange={( val ) => onChange( val ?? '' )}
				onBlur={handleBlur}
				placeholder={placeholder}
				className={`phone-input ${shouldShowError ? 'phone-input--invalid' : ''}`}
			/>
		</FormRow>
	)
}
